import { render, staticRenderFns } from "./CreatedAlbumsChat.vue?vue&type=template&id=7cf2da87&scoped=true&lang=html&"
import script from "./CreatedAlbumsChat.vue?vue&type=script&lang=js&"
export * from "./CreatedAlbumsChat.vue?vue&type=script&lang=js&"
import style0 from "./CreatedAlbumsChat.vue?vue&type=style&index=0&id=7cf2da87&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2da87",
  null
  
)

export default component.exports